export default __webpack_public_path__ + "static/media/menu.450e8692.PNG";